import { resolveHTMLElement } from './utilities';
export const getLogiEmbedMangerScript = () => {
    // TODO remove logi naming
    //@ts-ignore
    return (document.querySelector('script[data-name="composer-embed-manager"]') ||
        document.querySelector('script[data-name="logi-embed-manager"]'));
};
export const getComposerEmbedScript = () => {
    if (document.currentScript) {
        return document.currentScript;
    }
    //@ts-ignore
    return document.querySelector('script[data-name="composer-embed"]');
};
export const createModalContainer = (context) => {
    let { modalContainer } = context;
    if (modalContainer) {
        const resolvedModalContainer = resolveHTMLElement(modalContainer);
        resolvedModalContainer.classList.add('logi-embed');
        if (!resolvedModalContainer.id) {
            resolvedModalContainer.id = 'logi-modal-root';
        }
        context.modalContainer = resolvedModalContainer;
        return context;
    }
    // create element for composer modals
    modalContainer = document.createElement('div');
    modalContainer.className = 'logi-embed';
    modalContainer.id = 'logi-modal-root';
    document.body.appendChild(modalContainer);
    context.modalContainer = modalContainer;
    return context;
};
export const createStyleContainer = (context) => {
    // create element for composer emotion styles
    const styleContainer = document.createElement('div');
    styleContainer.id = 'logi-styles-root';
    document.body.appendChild(styleContainer);
    context.styleContainer = styleContainer;
    return context;
};
//# sourceMappingURL=elements.js.map